import React from "react";
import { Grid, Box, Typography, Button, useTheme, Alert } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import InfoIcon from "@mui/icons-material/Info";
import HistoricalSignalsList from "./HistoricalSignalsList";
import PortfolioSummary from "./PortfolioSummary";

const HistoricalSignalsDisplay = ({
  strategies,
  strategyValObj,
  strategyVal,
  onDownload,
  hasData,
  historicalSignalSet,
}) => {
  const theme = useTheme();

  if (!strategyVal) {
    return (
      <Box
        sx={{
          textAlign: "center",
          py: 8,
          color: theme.palette.text.secondary,
        }}
      >
        <Typography variant="h5">
          Please select a strategy to view historical signals
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          {/* Header */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: 600,
                color: theme.palette.text.primary,
                fontSize: "1.1rem",
              }}
            >
              Historical Signals
            </Typography>
            <button
              onClick={onDownload}
              disabled={!hasData}
              style={{
                backgroundColor: !hasData ? "#cccccc" : "#4caf50",
                color: !hasData ? "#666666" : "white",
                fontWeight: 500,
                textTransform: "none",
                border: "none",
                borderRadius: "4px",
                padding: "8px 16px",
                fontSize: "14px",
                cursor: !hasData ? "not-allowed" : "pointer",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                fontFamily: "inherit",
                minHeight: "36px",
                boxShadow: !hasData 
                  ? "none"
                  : "0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)",
                opacity: !hasData ? 0.6 : 1,
              }}
              onMouseEnter={(e) => {
                if (!hasData) return;
                e.target.style.backgroundColor = "#388e3c";
              }}
              onMouseLeave={(e) => {
                if (!hasData) return;
                e.target.style.backgroundColor = "#4caf50";
              }}
            >
              <DownloadIcon style={{ fontSize: "20px" }} />
              Download All
            </button>
          </Box>

          {/* Performance Disclaimer */}
          {hasData && (
            <Alert
              icon={<InfoIcon />}
              severity="info"
              sx={{
                mb: 3,
                borderRadius: 2,
                backgroundColor: theme.palette.mode === 'dark' 
                  ? 'rgba(2, 136, 209, 0.1)' 
                  : 'rgba(2, 136, 209, 0.1)',
                border: `1px solid ${theme.palette.mode === 'dark' 
                  ? 'rgba(2, 136, 209, 0.3)' 
                  : 'rgba(2, 136, 209, 0.3)'}`,
                '& .MuiAlert-icon': {
                  color: theme.palette.info.main,
                },
                '& .MuiAlert-message': {
                  color: theme.palette.text.primary,
                },
              }}
            >
              <Typography variant="body2">
                Historical performance data does not include commissions, fees, trading expenses or slippage.
              </Typography>
            </Alert>
          )}

          {/* Portfolio Summary */}
          {hasData && historicalSignalSet?.portfolioPeriodMetrics && (
            <PortfolioSummary portfolioPeriodMetrics={historicalSignalSet.portfolioPeriodMetrics} />
          )}

          <HistoricalSignalsList
            strategies={strategies}
            strategyValObj={strategyValObj}
            strategyVal={strategyVal}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default HistoricalSignalsDisplay;
